import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { APP_CONFIG } from '../../../configs/app-config.constants';
import { InterfaceAppConfig } from '../../../configs/app-interface.config';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { MsalService } from '@azure/msal-angular';
import { b2cPolicies } from 'src/app/config/auth-config';
import { CommonServiceService } from '../common-service/common-service.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private timeoutId: any;
    private readonly TIMEOUT_DURATION = 30 * (60 * 1000); // 30 minutes in milliseconds

    url: any;
    domainUrl = environment.apiurl;
    gyanDomainUrl = environment.gyanApiUrl;
    constructor(
        private http: HttpClient,
        private cookieService: CookieService,
        private msalService: MsalService,
        private commonServiceService: CommonServiceService,
        private localStorageService: LocalStorageService,
        @Inject(APP_CONFIG)
        private config: InterfaceAppConfig,
    ) {
        if (!this.isSignInUser()) {
            this.setCookie('g-ap-guest', 'true', 30000, environment.cookieDomain);
        }
        if (this.getCookie('g-ap-p-iv') !== 'false') {
            this.setCookie('g-ap-p-iv', 'true', 30000, environment.cookieDomain);
        }
    }
    getIsVerified() {
        return this.getCookie('g-ap-p-iv');
    }
    getIsGuest() {
        return this.getCookie('g-ap-guest');
    }
    getGyanCookie() {
        return this.getCookie('g-ap-gapi-c');
    }
    deleteCookieForce() {
        console.log('document.cookie', document.cookie);
        console.log('environment', environment);
        //alert(document.cookie);
        //debugger;
        this.cookieService.delete('g-ap-g-tkn', '/', environment.cookieDomain);
        this.deleteCookie('g-ap-g-tkn');
        this.cookieService.delete('g-ap-obj', '/', environment.cookieDomain);
        this.deleteCookie('g-ap-obj');
        this.cookieService.delete('g-ap-obj-tkn', '/', environment.cookieDomain);
        this.deleteCookie('g-ap-obj-tkn');
        this.cookieService.delete('g-ap-p-iv', '/', environment.cookieDomain);
        this.deleteCookie('g-ap-p-iv');

        this.cookieService.delete('g-ap-p-id', '/', environment.cookieDomain);
        this.deleteCookie('g-ap-p-id');
        this.cookieService.delete('g-ap-u-id', '/', environment.cookieDomain);
        this.deleteCookie('g-ap-u-id');
        this.cookieService.delete('g-ap-p-fn', '/', environment.cookieDomain);
        this.deleteCookie('g-ap-p-fn');
        this.cookieService.delete('g-ap-p-ln', '/', environment.cookieDomain);
        this.deleteCookie('g-ap-p-ln');
        this.cookieService.delete('g-ap-p-eid', '/', environment.cookieDomain);
        this.deleteCookie('g-ap-p-eid');
        this.cookieService.delete('g-ap-p-iv', '/', environment.cookieDomain);
        this.deleteCookie('g-ap-p-iv');
        this.cookieService.delete('g-ap-guest', '/', environment.cookieDomain);
        this.deleteCookie('g-ap-guest');
    }

    deleteCookiesForce() {
        console.log('document.cookie', document.cookie);
        console.log('environment', environment);
        //alert(document.cookie);
        //debugger;
        this.cookieService.delete('g-ap-g-tkn', '/');
        this.cookieService.delete('g-ap-obj', '/');
        this.cookieService.delete('g-ap-obj-tkn', '/');
        this.cookieService.delete('g-ap-p-iv', '/');
        this.cookieService.delete('g-ap-p-id', '/');
        this.cookieService.delete('g-ap-u-id', '/');
        this.cookieService.delete('g-ap-p-fn', '/');
        this.cookieService.delete('g-ap-p-ln', '/');
        this.cookieService.delete('g-ap-p-eid', '/');
        this.cookieService.delete('g-ap-p-iv', '/');
        this.cookieService.delete('g-ap-guest', '/');
    }
    getGyanLoginToken() {
        return this.getCookie('g-ap-g-tkn');
    }
    getAuthToken() {
        return this.getCookie('g-ap-obj-tkn');
    }
    setCallPreviousSearchGyan() {
        this.commonServiceService.setCallPreviousSearchGyan(true);
    }
    clearTimerTimeout() {
        this.clearTimeout();
    }
    startAutoLogout() {
        //console.log('startAutoLogout');
        // Clear any existing timeout
        this.clearTimeout();

        // Set timeout to automatically logout after TIMEOUT_DURATION
        this.timeoutId = setTimeout(() => {
            console.log('setTimeout');
            // Call logout function here
            this.logout();
        }, this.TIMEOUT_DURATION);
    }
    private clearTimeout() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    resetAutoLogout() {
        if (this.isSignInUser()) {
            this.clearTimeout();
            this.startAutoLogout();
        }
    }
    getSsoResponse(): Observable<any> {
        const timeZoneary = new Date().toString().match(/([A-Z]+[\+-][0-9]+)/);

        const url = this.domainUrl + this.config.apis.auth.ssoResponse + '?timeZone=' + timeZoneary![0].toString();
        return this.http.get(url);
    }
    getPersonId() {
        if (this.getCookie('g-ap-p-id') === '' || this.getCookie('g-ap-p-id') === undefined || this.getCookie('g-ap-p-id') === null) {
            return 0;
        } else {
            const personId = this.getCookie('g-ap-p-id')?.toString();
            if (typeof personId === 'string') {
                return Number.parseInt(personId, 10);
            } else {
                console.error('personId is not a string');
                return 0; // Or handle the error as needed
            }
        }
    }
    getUserId() {
        if (this.getCookie('g-ap-u-id') === '' || this.getCookie('g-ap-u-id') === undefined || this.getCookie('g-ap-u-id') === null) {
            return 0;
        } else {
            const personId = this.getCookie('g-ap-u-id')?.toString();
            if (typeof personId === 'string') {
                return Number.parseInt(personId, 10);
            } else {
                console.error('personId is not a string');
                return 0; // Or handle the error as needed
            }
        }
    }
    guestSignUp(data: any): Observable<any> {
        const url = this.domainUrl + this.config.apis.auth.guestSignUp;
        return this.http.post(url, data);
    }
    verifyUser(data: any): Observable<any> {
        const url = this.domainUrl + this.config.apis.auth.verifyUser;
        return this.http.post(url, data);
    }
    isEmailExists(email: string): Observable<any> {
        const url = this.domainUrl + this.config.apis.auth.isEmailExists;
        return this.http.get(url + '?email=' + encodeURIComponent(email));
    }
    signUp(data: any): Observable<any> {
        const url = this.domainUrl + this.config.apis.auth.signUp;
        return this.http.post(url, data);
    }
    generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
    gyanAuthLogin(loginToken: string, isDefaultSub: boolean, timeZone: string): Observable<any> {
        const apiUrl = this.gyanDomainUrl + this.config.apis.gyan.azureTokenLogin;
        const data = JSON.stringify({
            loginToken: loginToken,
            timeZone: timeZone,
            isDefaultSub: isDefaultSub,
        });
        return this.http.post(apiUrl, data, {
            observe: 'response',
            withCredentials: true,
            responseType: 'json',
        });
    }
    gyanAuthLogout(): Observable<any> {
        const apiUrl = this.gyanDomainUrl + this.config.apis.gyan.logout;
        return this.http.get(apiUrl, {
            observe: 'response',
            responseType: 'json',
        });
    }
    getSessionTokenFromGyan() {
        const cookies: { [key: string]: string } = {};
        const cookieString = document.cookie;
        if (cookieString) {
            const cookieArray = cookieString.split('; ');
            for (const cookie of cookieArray) {
                const [name, value] = cookie.split('=');
                cookies[name] = decodeURIComponent(value);
            }
        }
        console.log('cookies');
        console.log(cookies);
    }
    callGyanAuth() {
        const timeZoneary = new Date().toString().match(/([A-Z]+[\+-][0-9]+)/);

        //new Date().toString().match(/([A-Z]+[\+-][0-9]+)/)[1];
        this.gyanAuthLogin(this.getAuthToken(), false, timeZoneary![0].toString()).subscribe(
            (response: HttpResponse<any>) => {
                console.log('Login successful:', response);
                // Access the headers
                const headers = response.headers;
                console.log('Login successful:', response);
                const setCookieHeader = response.headers.get('Set-Cookie');
                console.log('Set-Cookie header:', setCookieHeader);
                this.setUserDetails(response.body);
                // if (response != undefined && response != null && response != '') {
                //     if (response.message === 'Please find the verification link in your email and click it to log in.') {
                //         //      localStorage.clear();
                //     } else {
                //         this.getSessionTokenFromGyan();
                //         //    localStorage.clear();
                //         this.setCookie('g-ap-gobj-ud', JSON.stringify(response), 30000, environment.cookieDomain);
                //     }
                // }
            },
            (error) => {
                console.log(error);
            },
        );
    }

    setTokenId() {
        const strIdToken: any = sessionStorage.getItem('msal.token.keys.' + environment.azureAdB2CAuthClientId);
        const itemToken: any = JSON.parse(strIdToken);
        const jwtToken: any = sessionStorage.getItem(itemToken.idToken[0]);
        const strJwtToken = jwtToken;
        if (strJwtToken !== null) {
            const itemJwtToken: any = JSON.parse(strJwtToken);
            this.setCookie('g-ap-obj', JSON.stringify(itemToken), 30000, environment.cookieDomain);
            this.setCookie('g-ap-obj-tkn', itemJwtToken.secret, 30000, environment.cookieDomain);
        }
    }
    forgotPassword() {
        const resetPasswordRequest = {
            authority: b2cPolicies.authorities.resetPassword.authority,
            scopes: ['openid', 'profile'], // Define necessary scopes for the reset password flow
            redirectUri: window.location.origin, // Redirect URI after the password reset process completes
            responseType: 'code', // Response type
        };

        // Initiate the forgot password flow
        this.msalService.loginRedirect(resetPasswordRequest);
    }

    logout() {
        console.log('logout Called');
        // debugger;
        this.gyanAuthLogout().subscribe((response: any) => {
            localStorage.setItem('msalLogoutEvent', Date.now().toString());
            this.msalService.logout();
            //this.deleteCookieForce();
            this.deleteCookiesForce();
            // alert('deleteCookieForce');

            this.cookieService.deleteAll(environment.cookieDomain);
            sessionStorage.clear();
            localStorage.clear();
        });
    }
    setLoginSession() {
        this.setCookie('g-ap-guest', 'false', 30000, environment.cookieDomain);
        this.setTokenId();

        this.callGyanAuth();

        this.getSsoResponse().subscribe(
            (response: any) => {
                this.clearTimeout();
                //   alert('setLoginSession');
                this.startAutoLogout();
                this.setCookie('g-ap-ps-no', '0', 30000, environment.cookieDomain);
                this.setCookie('g-ap-p-id', response.personId.toString(), 30000, environment.cookieDomain);
                this.setCookie('g-ap-u-id', response.userId.toString(), 30000, environment.cookieDomain);
                this.setCookie('g-ap-p-fn', response.firstName.toString(), 30000, environment.cookieDomain);
                this.setCookie('g-ap-p-ln', response.lastName.toString(), 30000, environment.cookieDomain);
                this.setCookie('g-ap-p-eid', response.email.toString(), 30000, environment.cookieDomain);

                this.setCookie('g-ap-p-iv', response.isVerified.toString(), 30000, environment.cookieDomain);

                this.commonServiceService.setCallPreviousSearchGyan(true);
            },
            (error: HttpErrorResponse) => {
                console.log('error');
                console.log(error);
            },
        );
    }
    setPageNos(pageNo: string) {
        this.setCookie('g-ap-ps-no', pageNo.toString(), 30000, environment.cookieDomain);
    }
    getPageNos() {
        return this.getCookie('g-ap-ps-no');
    }
    createGuestSignUp() {
        const uuId = this.generateUUID();
        //this.setCookie('g-ap-guest', 'false', 30000, environment.cookieDomain);
        this.guestSignUp({
            uuid: uuId,
            email: uuId + '@gyan.com',
            clientUrlName: 'Gyan',
            userGroupUrlName: 'GuestUser',
            browserDetails: '{}',
        }).subscribe(
            (response: any) => {
                this.setCookie('g-ap-p-id', response.personId.toString(), 30000, environment.cookieDomain);
                this.setCookie('g-ap-guest', 'true', 30000, environment.cookieDomain);
                this.setCookie('g-ap-guest-uuid', uuId, 30000, environment.cookieDomain);
            },
            (error: HttpErrorResponse) => {
                console.log('error');
                console.log(error);
            },
        );
    }
    getSignInUser() {
        if (this.isSignInUser()) {
            return this.getCookie('g-ap-p-fn')?.toString();
        } else {
            return 'Sign In';
        }
    }
    isSignInUser() {
        return this.getCookie('g-ap-obj-tkn') ? true : false;
    }

    getCookie(name: string) {
        return this.cookieService.get(name);
        // const nameEQ = name + '=';
        // const cookies = document.cookie.split(';');
        // for (let i = 0; i < cookies.length; i++) {
        //     let cookie = cookies[i];
        //     while (cookie.charAt(0) == ' ') {
        //         cookie = cookie.substring(1, cookie.length);
        //     }
        //     if (cookie.indexOf(nameEQ) == 0) {
        //         return cookie.substring(nameEQ.length, cookie.length);
        //     }
        // }
        // return null;
    }
    deleteCookie(name: string) {
        document.cookie = name + '=; Max-Age=-99999999;';
    }
    setCookie(name: string, value: string, days: number, domain: string) {
        this.cookieService.set(name, value, 999, domain);
        // let expires = '';
        // if (days) {
        //     const date = new Date();
        //     date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        //     expires = '; expires=' + date.toUTCString();
        // }
        // document.cookie = name + '=' + (value || '') + expires + '; domain=' + domain + '; path=/';
    }

    getGuestSignUpJson() {
        const uuId = this.generateUUID();
        //this.setCookie('g-ap-guest', 'false', 30000, environment.cookieDomain);
        return {
            uuid: uuId,
            email: uuId + '@gyan.com',
            clientUrlName: 'Gyan',
            userGroupUrlName: 'GuestUser',
            browserDetails: '{}',
        };
    }
    setGuestSignUpResponse(user: any, uuId: string) {
        // alert('startAutoLogout');
        this.setCookie('g-ap-ps-no', '0', 30000, environment.cookieDomain);
        this.setCookie('g-ap-p-id', user.personId.toString(), 30000, environment.cookieDomain);
        this.setCookie('g-ap-u-id', user.userId.toString(), 30000, environment.cookieDomain);
        this.setCookie('g-ap-p-iv', 'true', 30000, environment.cookieDomain);
        this.setCookie('g-ap-guest', 'true', 30000, environment.cookieDomain);
        this.setCookie('g-ap-guest-uuid', uuId, 30000, environment.cookieDomain);
    }

    getUserDetails(item: string) {
        this.localStorageService.getItem('userDetails');
    }

    setUserDetails(item: string) {
        this.localStorageService.setItem('userDetails', item);
    }

    getAccessList(keyName: any) {
        const accessList = this.localStorageService.getItem('userDetails')?.accessList;
        return accessList?.indexOf(keyName) >= 0 ? true : false;
    }
}
